import { numberToWords } from '@persian-tools/persian-tools';

/**
 * What patients see as the product's name. «دبّه» is the internal code name only and is never shown;
 * change the shown name here.
 */
export const DABBEH_NAME = 'صف ثبت نوبت';

/**
 * Real payment through Paziresh24 Plus (see ./billing.ts): the queue's product on plus.paziresh24.com.
 * Empty = the prototype's instant purchase.
 */
export const DABBEH_PLUS_PRODUCT = 'patient_plus';

/**
 * «دبّه», the queue service (repo Mohammadi/dabbeh, https://dabbeh.p24cloud.ir), reached through this site's
 * own origin (next.config.js rewrite) so the login cookie goes along. Empty = the queue lives on this device
 * only (prototype). See ./api.ts.
 */
export const DABBEH_API_URL = '/booking-queue/api';

/**
 * «احتمال نوبت‌گیری پزشک» widget, served by the same dabbeh service (its appointment-odds folder) through the same
 * proxy as DABBEH_API_URL. It gives the line above the queue box (./demand.ts). Trailing slash: trailingSlash:true.
 */
export const DABBEH_ODDS_URL = '/booking-queue/api/odds/widget/';

/** Monthly subscription price (toman). With real billing the plan's own price is shown instead. */
export const DABBEH_PRICE_TOMAN = 49_000;

/** Length of one subscription. */
export const DABBEH_SUBSCRIPTION_DAYS = 30;

/** How long a released appointment is held for the patient before it passes to the next person in line. */
export const DABBEH_HOLD_MINUTES = 20;

/**
 * The patient is told by SMS when a slot is reserved for them. Off until the SMS really goes out: until then
 * no text promises one (the reserved slot shows in «نوبت‌های من»). Turn on together with the SMS itself.
 */
export const DABBEH_SMS_LIVE = false;

/** People already waiting before the patient joins, until the service reports the real number (the sheet never shows this placeholder). */
export const DABBEH_QUEUE_AHEAD = 12;

/** Same support channel the booking receipt opens. */
export const DABBEH_SUPPORT_URL = 'https://support.paziresh24.com/chats/new?department=3';

export const DABBEH_ROUTES = {
  checkout: '/booking-queue/checkout/',
  receipt: '/booking-queue/receipt/',
  myTurns: '/patient/appointments/',
} as const;

export const faNumber = (value: number) => value.toLocaleString('fa-IR');
/** «۴۹,۰۰۰» — the comma grouping used across the booking pages. */
export const faPrice = (value: number) => value.toLocaleString('fa-IR').replace(/٬/g, ',');

/**
 * A place in line, in words: «نفر اول»، «نفر دوم»، «نفر بیستم»، «نفر بیست و یکم» (never «نفر ۲۰ ام»).
 * Only for the patient's own place; how many people wait is a count («۷ نفر»), see faNumber.
 */
export const faSeat = (position: number) => {
  const n = Math.max(1, Math.floor(position));
  if (n === 1) return 'نفر اول';
  const words = numberToWords(n, { ordinal: true });
  return typeof words === 'string' ? `نفر ${words.replace(/ اُم$/, '‌ام')}` : `نفر ${faNumber(n)}`;
};
